import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-12963cd1")

_pushScopeId("data-v-12963cd1")
const _hoisted_1 = { class: "price" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.price)
    ? (_openBlock(), _createBlock("span", {
        key: 0,
        class: "price_label p-a df-middle",
        style: _ctx.position
      }, [
        _createVNode("span", _hoisted_1, _toDisplayString(_ctx.price), 1)
      ], 4))
    : _createCommentVNode("", true)
})